import { Component, input, output } from "@angular/core";
import { IAllSearch, StatusInfo } from "../../../interfaces";
import { NgClass } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import { MatMiniFabButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { HighlightDirective } from "../../directives/highlight.directive";
import { TimezoneOffsetPipe } from "../../pipes/timezone-offset.pipe";
import { TelPipe } from "../../pipes/tel.filter";
import { RouterLink } from "@angular/router";

@Component({
    selector: "location-result",
    templateUrl: "./location-result.component.html",
    styleUrl: "./location-result.component.scss",
    imports: [
        NgClass,
        MatIcon,
        MatMiniFabButton,
        MatTooltip,
        HighlightDirective,
        TimezoneOffsetPipe,
        TelPipe,
        RouterLink,
    ],
    providers: [TelPipe],
})
export class LocationResultComponent {
    item = input.required<IAllSearch>();
    searchTerm = input.required<string>();
    shortcutClick = output<void>();

    get fullAddress(): string {
        const parts = [this.item().Address1, this.item().City, this.item().State, this.item().ZIP].filter(Boolean);

        return parts.join(", ");
    }

    get primaryId(): string {
        return `${this.item().GroupID} - ${this.item().Name}`;
    }

    get backgroundClass(): string {
        const status = this.locationStatus;
        if (status.level === "danger") return "location-danger";
        if (status.level === "warning") return "location-warning";

        return "";
    }

    get locationStatus(): StatusInfo {
        // Should actually get expire date time, but not on search
        const { History } = this.item();

        // if (History) {
        //     return { level: "danger", text: "Inactive" };
        // }

        if (History) {
            return { level: "warning", text: "Historical" };
        }

        return { level: "normal" };
    }

    gridButton() {
        this.shortcutClick.emit();
    }
}
